import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

const CAN_OVERRIDE_RESET_SAFETY_CHECK = gql(`
  query CanCurrentUserOverrideResetSafetyCheck {
    canCurrentUserOverrideResetSafetyCheck
  }
`);

/**
 * Hook to check if the current user can reset unsafe reports.
 *
 * All staff can reset safe reports.
 * Only allowlisted users can reset unsafe reports (by overriding the safety check).
 */
export function useResetSafetyOverrideAuth() {
  const { data, loading } = useQuery(CAN_OVERRIDE_RESET_SAFETY_CHECK);

  return {
    canOverrideSafetyCheck: data?.canCurrentUserOverrideResetSafetyCheck ?? false,
    loading,
  };
}
